"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHOW_NOTIFICATION = exports.CLEAR_NOTIFICATION = void 0;
var SHOW_NOTIFICATION = exports.SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
var CLEAR_NOTIFICATION = exports.CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';